import { z } from "zod";
import { MCP_TOKEN_NAME_MAX_LENGTH } from "../../constants/mcp.js";
export const createMcpTokenSchema = z.object({
    name: z.string().min(1).max(MCP_TOKEN_NAME_MAX_LENGTH),
});
export const AdminMcpTokenSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    tokenPrefix: z.string(),
    expiresAt: z.string(),
    lastUsedAt: z.string().nullable(),
    createdAt: z.string(),
});
export const AdminMcpTokenListSchema = z.object({
    tokens: z.array(AdminMcpTokenSchema),
});
export const AdminMcpTokenCreatedSchema = z.object({
    token: AdminMcpTokenSchema,
    secret: z.string(),
});
